module.exports = __webpack_public_path__ + "media/notification_1.4367b5f2.wav";